<template>
  <div class="picmanger">
    <div class="header">
      <div style="display: flex; align-items: center">
        <img
          src="@/assets/house/breadicon.png"
          style="margin-right: 10px"
          alt
        />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>数智中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{ sortType }}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
    </div>

    <div class="main" v-loading="isRefresh">
      <div class="head">
        <h4>{{  sortType  }}</h4>
        <el-radio-group v-model="sortType" @input="sortTypeChange">
                  <el-radio-button label="标签统计"></el-radio-button>
                  <el-radio-button label="分类统计"></el-radio-button>
                </el-radio-group>
      </div>
      <div class="search-header" style="position: relative;z-index: 2;min-width: 700px;">
        <div style="height: 32px;width: 100%">
          <div  style="width: 100%;display: flex; justify-content: space-between;">
              <div style="display: flex; justify-content: flex-start;gap: 20px;">
                
                
                
                <el-radio-group v-model="chartType">
                  <el-radio-button label="全部"></el-radio-button>
                  <el-radio-button label="月度"></el-radio-button>
                  <el-radio-button label="年度"></el-radio-button>
                </el-radio-group>
                <el-date-picker
                v-show="chartType=='月度'"
                  v-model="selectMonth"
                  type="month"
                  :clearable="false"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  placeholder="请选择月份">
                </el-date-picker>
                <el-date-picker
                v-show="chartType=='年度'"
                  v-model="selectYear"
                  type="year"
                  :clearable="false"
                  format="yyyy 年"
                  value-format="yyyy"
                  placeholder="选择年份">
                </el-date-picker>
                <!-- <el-select v-model="resourceType" v-if="sortType=='分类统计'" placeholder="请选择资源类型">
                  <el-option
                    v-for="item in mediaOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select> -->
              </div>
              <div>
                <el-button type="primary" icon="el-icon-upload2" @click="exportExcel()">导出</el-button>
                <el-button  type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                <el-button type="danger" @click="reset()" icon="el-icon-refresh">重置</el-button>
              </div>
          </div>
        </div>
      </div>

      
      <div class="tablebg" style="position: relative;z-index: 1;">
        <com-table
          ref="comTable"
          :columns="sortType=='标签统计'?toAltasColumns:downAltasColumns"
          :data="tableList"
          v-if="!isRefresh"
          :height="tableHeight"
          :show-summary='showSummary'
          :pagination="pagination"
          @getData="fetchTableList"
          :loading="loading"
          >
          <template slot="type" slot-scope="{row}">
            <el-tag :type="row.type=='picture'?'':'danger'" effect="dark">
            {{ row.type=='picture'?'图片':'视频' }}
            </el-tag>
          </template>

          <template  slot="detail" slot-scope="{row,index}">
            <div v-if="row.type=='picture'" style="height: 30px;cursor: pointer;" @click="previewResource(row,index)">
              <img style="height: 100%;" v-if="row.fileInfo.picThumbH160" :src="picPrefix + row.fileInfo.picThumbH160" alt="">
              <img style="height: 100%;" v-else :src="picPrefix+row.fileInfo.savepath" alt="">
            </div>
            <div v-else style="height: 30px;cursor: pointer;" @click="previewResource(row,index)">
              <video v-if="row.fileInfo" style="height: 100%;" :src="picPrefix+row.fileInfo.savepath"></video>
            </div>
          </template>
          <template slot="atlasInfo" slot-scope="{row}">
            <el-link v-if="row.atlasInfo" type="primary" @click="goAtlasInfo(row.atlasInfo.id)">{{ row.atlasInfo.name }}</el-link>
            
          </template>
          

        </com-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="resourcePreview"
      width="1000px"
      >
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <h3>预览</h3>
        <el-button icon="el-icon-close" circle @click="handleClose"></el-button>
      </div>
      <div style="height: 400px;margin-top: 20px;">
        <div class="swiper-button-prev" slot="button-prev"></div>

        <swiper ref="mySwiper"
        :options="swiperOption">
            <swiper-slide v-for='(item, index) in tableList' style="display: flex;justify-content: center;align-items: center;" :key='index'>
              <video v-if="item.type=='video'&&item.fileInfo"
                    :src="picPrefix+item.fileInfo.savepath"
                    style="height: 400px;"
                    controls
                    muted
                    class="multimedia"></video>
                    <img v-if="item.type=='picture'&&item.fileInfo"
                    style="height: 400px;"
                    :src="picPrefix+item.fileInfo.savepath"
                    class="multimedia">
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>
        <div class="swiper-button-next" slot="button-next"></div>

        <!-- <swiper :options="swiperOption"
            style="width: 800px;"
                ref="videoSwiper">
                <swiper-slide v-for="( item , index ) in tableList"
                    :key="index">
                    <video v-if="item.type=='video'&&item.fileInfo"
                    :src="picPrefix+item.fileInfo.savepath"
                    controls
                    muted
                    @ended="endVideo(index)"
                    class="multimedia"></video>
                    <img v-if="item.type=='picture'&&item.fileInfo"
                    style="height: 400px;"
                    :src="picPrefix+item.fileInfo.savepath"
                    class="multimedia">
                </swiper-slide>
                <div class="swiper-pagination"
                    v-for="(item,index) in tableList"
                    :key="index"
                    slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
        </swiper> -->
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import { picPrefix } from "@/constants/piccommon";

import { comTable } from '@/components/index';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
// import Swiper2, {  Autoplay } from "swiper";
// Swiper2.use([Navigation, Pagination, EffectFade, Autoplay]);

// import vns from 'vue-number-scroll'
// import { getOverview } from '@/api/resourceLog'
// import { dataecharts } from '@/components/index'
// import { formatConversion } from '@/plugins/getdate'

import { getLabelStatisticsApi } from '@/api/label'
import { getClassifyStatisticsApi } from '@/api/classify'
import { listDownResourceRank } from '@/api/picturePackage'
export default {
  name:'datastatic',
  components: {
    comTable,
    swiper, swiperSlide
    // 'vns':vns,
    // 'data-echarts':dataecharts
  },
  data() {
    return {
      isExport:0,
      resourcePreview:false,
      sortType:'标签统计',
      showSummary:true,
      chartType: '全部',
      type: 0,
      data: '',
      picPrefix,
      selectMonth: '',
      selectYear: '',
      tableHeight:600,
      // formatConversion,
      isRefresh: false,
      loading: true,
      toAltasColumns: [
        // { type: 'index',label:'排名' },
        { prop: 'name', label: '标签名称', width: 250 },
        { prop: 'picCount', label: '共享图片量', minWidth: 160 },
        { prop: 'videoCount', label: '共享视频量', minWidth: 160 },
        { prop: 'points', label: '积分', minWidth: 160},
        // { slot: 'operation', label: '操作' ,width: 160}
      ],
      downAltasColumns: [
        { prop: 'name', label: '分类名称', width: 250 },
        { prop: 'picCount', label: '共享图片量', minWidth: 160 },
        { prop: 'videoCount', label: '共享视频量', minWidth: 160 },
        { prop: 'points', label: '积分', minWidth: 160},
      ],
      tableList: [],
      pagination: {
        current: 1,
        size: 10,
        total: 20
      },
      // mediaOptions: [
      //   {
      //     label: '全部资源',
      //     value:'-1'
      //   },
      //   {
      //     label: '图片资源',
      //     value:'picture'
      //   },
      //   {
      //     label: '视频资源',
      //     value:'video'
      //   },
      // ],
      // swiperOption: {
      //           // speed: 1000,
      //           // loop: false,
      //           // observer: true,
      //           // observeParents: true,
      //           // autoplayDisableOnInteraction: false,
      //           allowTouchMove: true,
      //           spaceBetween:10,
      //           navigation: {
      //               prevEl:'.swiper-button-prev',//上-张
      //               nextEl:'.swiper-button-next',//下-张
      //           },
      //           thumbs: {
      //               swiper: {
      //                   el: ".gallery-thumbs",
      //                   slidesPerview: 6,//缩略图显示张数
      //                   slidesPerGroup: 6,//缩略图每组切图张数
      //                   spaceBetween: 10,//缩略图间距
      //                   slideToclickedslide: true,
      //                   navigation: {//缩略图的切图按钮，如果想放在轮播图中可以看swiper官方文档
      //                       nextEl: "swiper-button-next",
      //                       prevEl: "swiper-button-prev",
      //                   }
      //               }
      //           },
      //           autoScrolloffset:true,
      //           mousewheelControl: true,
      //           // pagination: {
      //           //     el: '.swiper-pagination',
      //           //     clickable: true
      //           // },
      //           // on: {
      //           // slideChangeTransitionEnd: () => {
      //           //     this.slideChangeTransitionEndHandle()
      //           // },
      //           // slideChangeTransitionStart: () => {
      //           //     this.slideChangeTransitionStartHandle()
      //           // },
      //           // //控制第一个slide切换
      //           // init: () => {
      //           //     this.initHandle()
      //           // }
      //           // }
      // },
      swiperOption: {
                // 自动切换
                // autoplay: true,
                // 环路
                loop: true,
                // 前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 分页器
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable :true
                // },
                // 切换效果cube
                // effect : 'cube',
                // cubeEffect: {
                //     slideShadows: true,
                //     shadow: true,
                //     shadowOffset: 100,
                //     shadowScale: 0.7
                // },
            },
    };
  },
  methods: {
    exportExcel() {
      this.$confirm(`当前导出内容是搜索的所有【${this.sortType}】,是否继续？`,'导出提示', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(e => {
          this.isExport = 1
          this.fetchTableList()
        })
        .catch(e => {
          
        });
    },
    activeIndexChange(index) { 
      console.log(index);
    },
    
    previewResource(rowData, index) {
      this.resourcePreview = true
      console.log(rowData, index);
      // this.initFlag = true
      this.$nextTick(() => {
        this.$refs.mySwiper.swiper.slideTo(index+1);
      })
    },
    handleClose() {
      this.resourcePreview = false
    },
    sortTypeChange() {
      this.isRefresh = true;
      setTimeout(() => {
        this.isRefresh = false;
      }, 160);
      this.reset()
    },
    reset() {
      this.resourceType = '-1';
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1;
      this.chartType='全部'
      this.selectMonth =currentYear+'-'+ currentMonth;
      this.selectYear = currentYear + '';
      this.fetchTableList()
    },
    search() {
      this.fetchTableList()
    },

    async fetchTableList() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.size,
      }
      if (this.isExport) {
        params.isExport=this.isExport
      }
      if (this.sortType=='分类统计' && this.resourceType!==-1) {
        params.resourceType = this.resourceType
      }
      if (this.chartType!=='全部') {
        params.type = this.chartType == '月度' ? 'month' : 'year'
        if (this.chartType == '月度') {
          console.log(this.selectMonth);
          params.date = this.selectMonth
        } else {
          console.log(this.selectYear);
          params.date = this.selectYear
        }
      }
      if (!this.isExport) {
        this.loading = true
        
      }
    // 分页时触发表单数据请求
      console.log(this.pagination)
      let api = this.sortType == '标签统计'?getLabelStatisticsApi:getClassifyStatisticsApi
      let {data,status,message,pagination} = await api(params)
      // console.log(data.list);
      if (status) {
        if (!this.isExport) {
          this.loading = false
          this.tableList = data.list;
          this.pagination.total = pagination.total;
        
        } else {
          this.isExport = 0
          this.$message.success({ message: `${message}请耐心等待...` })
          let downLoadUrl = this.picPrefix + data;
          console.log(downLoadUrl);
          let a = document.createElement("a");
          a.href = downLoadUrl;
          window.open(a.href, '_blank');
        }
      } else {
        this.$message.error(message)
      }
    }, 
  
  },
  created() {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    this.selectMonth =currentYear+'-'+ currentMonth;
    this.selectYear = currentYear+'';
    // this.isRefresh = true
    // this.getOverviewasync()
    this.fetchTableList();
    
  },
  beforeDestroy() {
    // 组件销毁前调用
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./datalabelclass.scss";
</style>
